export const getCarousel = async () => {
  if (window.createInteriorCarousel) return window.createInteriorCarousel;
  try {
    window.createInteriorCarousel = (
      await import("../carousel/interior-carousel")
    ).createInteriorCarousel;
    return window.createInteriorCarousel;
  } catch (err) {
    console.error("Ошибка загрузки createInteriorCarousel:", err);
  }
};
